/**
 * Created by sivanh on 11/06/2018.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");

    var RevisionedModel = require("models/RevisionedModel");
    var Config = require("manager-assets/config/config.json");
    var ApiResources = require("assets/data/apiResources.json");

    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var ScheduleEventsCollection = require("collections/entities/scheduling/ScheduleEventsCollection");

    var NAME ="ScheduleModel";

    var KEYS = {
        NAME: "name",
        DESCRIPTION: "description",
        IS_DEFAULT: "isDefault",
        EVENTS: "events",
    };

    var ScheduleModel = RevisionedModel.extend({
        KEYS: KEYS,
        name: NAME,
        resource: ApiResources.AccountConfig.WorkingHours,
        defaults: {
            name: "",
            description: "",
            isDefault: false,
            events: []
        },
        validation: {
            name: [
                {
                    required: true,
                    minLength: 1,
                    msg: "LEFramework.entities.schedule.errors.name.required"
                },
                {
                    maxLength: Config.validators.workdays.maxNameLength,
                    msg: "LEFramework.entities.schedule.errors.name.maxLength"
                }
            ],
            description: [
                {
                    required: false,
                    minLength: 0,
                    maxLength: Config.validators.workdays.maxDescriptionLength,
                    msg: "LEFramework.entities.schedule.errors.description.maxLength"
                }
            ],
            "events.0.start.dateTime": [
                {
                    fn: function() {
                        // validate hierarchy the collection
                        var eventsCollectionErrors = this.scheduleEventsCollection.validate();
                        if (!_.isEmpty(eventsCollectionErrors)) {
                            return "LEFramework.entities.schedule.errors.generalError.internalError";
                        }
                    }
                }
            ],
            "events.0.end.dateTime": [
                {
                    fn: function() {
                        var atLeastOneDayActive = this.scheduleEventsCollection.find(function(model) {
                            return (model.getType() !== ScheduleUtilities.EVENT_TYPES.INACTIVE);
                        });
                        if (!atLeastOneDayActive) {
                            return "LEFramework.entities.schedule.errors.all.off";
                        }
                    }
                }
            ]
        },

        initialize: function (attrs, options) {
            // scheduleEventsCollection can be initialized if the "parse" was triggered before the initialize.
            // this can be happened when the model is part of the collection, and we are doing collection fetch.
            if (!this.scheduleEventsCollection) {
                this.scheduleEventsCollection = new ScheduleEventsCollection();
                // if we got attrs in the initialize we want to init the scheduleEventsCollection with the events from the attributes, otherwise we want to put a default of "all hours".
                // we get these attrs when we clone the model
                if (attrs && attrs.events) {
                    this._parseScheduleEvents(attrs.events);
                    this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents(attrs.events);
                }
                else {
                    this._addDummyEventsToSchedule(ScheduleUtilities.EVENT_TYPES.ALL_HOURS);
                    this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents([]); // when we don't have events yet, getTimezoneFromEvents will return the default timezone
                }
            }

            RevisionedModel.prototype.initialize.call(this, options);
        },

        parse: function (response, options) {
            response = this._getModelFromResponse(response);

            var eventsArr = response.events;
            this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents(eventsArr);

            if (this.scheduleEventsCollection) {
                this.scheduleEventsCollection.reset();
            }
            else {
                this.scheduleEventsCollection = new ScheduleEventsCollection();
            }

            this._parseScheduleEvents(eventsArr);
            this._addDummyEventsToSchedule(ScheduleUtilities.EVENT_TYPES.INACTIVE);

            return RevisionedModel.prototype.parse.call(this, response, options);
        },

        getName: function () {
            return this.get(KEYS.NAME);
        },

        setName: function (name) {
            this.set(KEYS.NAME, name);
        },

        getDescription: function () {
            return this.get(KEYS.DESCRIPTION);
        },

        setDescription: function (description) {
            this.set(KEYS.DESCRIPTION, description);
        },

        getTimezone: function() {
            return this.parsedTimezone;
        },

        setTimezone: function(timezone) {
            this.parsedTimezone = timezone;
        },

        setEvents: function (eventsArr) {
            this.set(KEYS.EVENTS, eventsArr);
        },

        getScheduleEventsCollection: function () {
            return this.scheduleEventsCollection;
        },

        setIsDefault: function(isDefault) {
            this.set(KEYS.IS_DEFAULT, isDefault);
        },

        isDeletable: function() {
            return true;
        },

        isEditable: function() {
            return true;
        },

        isViewable: function() {
            return true;
        },

        isDuplicatable: function() {
            return true;
        },

        canSetUserDefault: function() {
            return false;
        },

        isSystemDefault: function() {
            return this.get(KEYS.IS_DEFAULT);
        },

        isUserDefault: function (){
            return this.isSystemDefault();
        },

        toJSON: function (options) {
            this.setEvents(ScheduleUtilities.createScheduleEventsApiFormat(this.getScheduleEventsCollection(), this.getTimezone()));
            var json = RevisionedModel.prototype.toJSON.apply(this, [].slice.apply(arguments));
            return json;
        },

        /**
         * check: name
         * @returns {boolean|*}
         */
        validateMandatoryFilled: function () {
          return  this._validateMandatoryFilled();
        },

        _getModelFromResponse: function (response) {
            if(_.isArray(response)) {
                response = _.find(response, {id:this.id});
            }
            return response;
        },

        _validateMandatoryFilled: function(){
            var hasName =  this.getName();

            //The trim is used to disable the save button in case that there are only spaces character in the input field
            hasName = hasName.trim();

            return hasName;
        },

        _parseScheduleEvents: function (eventsArr) {
            _.each(eventsArr, _.bind(function(eventObj) {
                var day = ScheduleUtilities.getScheduleEventDay(eventObj);

                if (_.isUndefined(this.scheduleEventsCollection.get(day))) {
                    //add the new eventModel to the collection
                    var attr = ScheduleUtilities.getParsedEvent(eventObj, day);
                    this._addEventModel(attr);
                }
                else {
                    this._updateExistingScheduleEvent(eventObj, day);
                }
            }, this));
        },

        _updateExistingScheduleEvent: function (eventObj, day) {
            var existingEventModel = this.scheduleEventsCollection.get(day);
            var eventType = ScheduleUtilities.getEventType(eventObj);

            if (existingEventModel.getType() === ScheduleUtilities.EVENT_TYPES.CUSTOM && eventType === ScheduleUtilities.EVENT_TYPES.CUSTOM) {
                var attr = ScheduleUtilities.getShiftFromEvent(eventObj);
                existingEventModel.addShiftItem(attr);
            }
            else { //if one of them is all hours
                existingEventModel.setType(ScheduleUtilities.EVENT_TYPES.ALL_HOURS);
            }
        },

        _addDummyEventsToSchedule: function (type) {
            var date;
            _.each(ScheduleUtilities.DAYS, _.bind(function (day) {
                if (_.isUndefined(this.scheduleEventsCollection.get(day))) {
                    date = ScheduleUtilities.getTheClosestDateOfARequestedDay(day);
                    var attr = {
                        id: day,
                        startDate: date,
                        endDate: date,
                        type: type,
                        shifts: []
                    };

                    //add the new eventModel to the collection
                    this._addEventModel(attr);
                }
            }, this));

        },

        _addEventModel: function (attr) {
            var Model = this.scheduleEventsCollection.model;
            this.scheduleEventsCollection.add(new Model(attr));
        }

    });

    ScheduleModel.NAME = NAME;
    ScheduleModel.KEYS = KEYS;

    return ScheduleModel;
});
